import React from "react";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        // Hook for reporting (Sentry, etc.)
        // eslint-disable-next-line no-console
        console.error("App error boundary:", error, info);
    }

    handleReload = () => {
        this.setState({ error: null });
        window.location.reload();
    };

    render() {
        if (this.state.error) {
            return (
                <div className="container py-5 text-center">
                    <h2 className="mb-3">Something went wrong</h2>
                    <p className="text-muted mb-4">
                        An unexpected error occurred. Please try reloading the page.
                    </p>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={this.handleReload}
                    >
                        Reload
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}
